import React,{useState,useEffect} from 'react';
import {uuidv4, renderOutput} from './operations/notebook'
// reactstrap components

import Editor from 'react-simple-code-editor';
import { highlight, languages } from 'prismjs';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-python';

const CodeHighlight = (props) => { 

const [getCode,setCode] = useState("");
const [getCopyText,setCopyText] = useState(false);
const url = window.location.href
const strgurl = new URLSearchParams((url).substring(url.indexOf('/')))

useEffect(() => {
  if (typeof props.codeValue === "string") {
    setCode(props.codeValue)
  }else{
    var newArray = props.codeValue.length !== 0?props.codeValue.join(''):props.codeValue;
     // set the current state
     setCode(newArray)
  }

}, [props]);

const onChangeEditor = (code,index)=>{
  setCode(code)
  props._getNewCode(code,index,true)
}

const handleClick = (e,name) => {
  setCopyText(true);
  setTimeout(() => {
    setCopyText(false);
    }, 3000);
  switch (e.detail) {
    case 1:
      // single click event 
      onCopyClick(name);
      break;
      default:
      break;
  }
};
//keyboard shortcut
const handlekeyDown = (e) => {
  var key = e.keyCode;
  switch(true) {
    case e.shiftKey && key === 13: // shift + enter press event here
    /** 
    * @param {*} user {currnetIndex, isSinglecell, cellFocusInsert}
    */
      props._codeCellRender(props.index, true, "focus");
      break;
    case e.ctrlKey && key === 13: //ctrl + Enter key press event her
    /**
    * 
    * @param {*} user {currnetIndex, isSinglecell, cellFocusInsert}
    */
      props._codeCellRender(props.index, true, "false");
      break;
    case (key === 18 && key === 13 ) || (e.altKey && key === 13 ): // alt + Enter key press event here
    /**
    * 
    * @param {*} user {currnetIndex, isSinglecell, cellFocusInsert}
    */
      props._codeCellRender(props.index, true, "insert");
      break;
    case e.ctrlKey && e.shiftKey && (key === 83 || key === 115): //ctrl + s key press event here
      props._saveCellRender(props.tabIndex);
      break;
    default:
      break
  }
}

const onCopyClick = (name) =>{
  var range = document.createRange();
  range.selectNode(document.getElementById("outputContent"+props.index));
  window.getSelection().removeAllRanges(); // clear current selection
  window.getSelection().addRange(range); // to select text
  document.execCommand("copy");
  window.getSelection().removeAllRanges();// 
}
  return (<div id={uuidv4()}>
        <div>
        <div className="div-code-style">
        <Editor
          className="codeStyle"
          value={getCode}
          onValueChange={code => onChangeEditor(code,props.index)}
          highlight={code => highlight(code, languages.py)}
          padding={10}
          index={props.index}
          onKeyDown = {(e) => handlekeyDown(e)}
        /> 
        </div>
        {props.output.length > 0 &&<div className="outputBorder">
        </div>
        }
        {props.output.length > 0 &&<div className="displaytxt highcode">
        <span title="Click To Copy" className="clickcopy float-right p-2 rounded">
          <span className={getCopyText ? "copiedBack" : ""}>{getCopyText ? "Copied" : ""}</span>
          <i className="fas fa-copy" onClick = {e=>handleClick(e,renderOutput(props.output))}></i></span>
        <pre><code><div id={"outputContent" + props.index} dangerouslySetInnerHTML={{__html:renderOutput(props.output)}}></div></code></pre>
        </div>
         }
         </div>              
    </div>
    )
};

export default CodeHighlight;